import React from "react";
import { useTranslation } from "react-i18next";
import ContactFormModal from "./overlays/ContactFormModal";

function OffCanvasMenuBar() {

    var translationHook = useTranslation();
    var i18n = translationHook.i18n;
    var t = translationHook.t;

    var [isModalOpen, setIsModalOpen] = React.useState(false);

    function changeLanguageToEnglish() {
        window.localStorage.setItem("i18nextLng", "en");
        i18n.changeLanguage("en");
    }

    function changeLanguageToRussian() {
        window.localStorage.setItem("i18nextLng", "ru");
        i18n.changeLanguage("ru");
    }

    /* function changeLanguageToFrench() {
        window.localStorage.setItem("i18nextLng", "fr");
        i18n.changeLanguage("fr");
    } */

    function changeLanguageToQazaq() {
        window.localStorage.setItem("i18nextLng", "kk");
        i18n.changeLanguage("kk");
    }

    return (
        <>
            <ContactFormModal
                isOpen={isModalOpen}
                onClose={function () { setIsModalOpen(false); }}
            />

            <div id="burgermenu" uk-offcanvas="overlay: true; flip: true">

                <div className="uk-offcanvas-bar">

                    {/* Navigation */}
                    <ul className="uk-nav uk-nav-default uk-margin-top">

                        <div className="uk-navbar-item uk-flex-between">

                            {/* Social icons */}
                            <a href="https://wa.me/77750912804" target="_blank" rel="noopener noreferrer" uk-icon="whatsapp"></a>
                            <a href="https://www.instagram.com/jai_agency.travels?igsh=MXZ1cmczNHlwZ3U3cg==&utm_source=ig_contact_invite" target="_blank" rel="noopener noreferrer" uk-icon="instagram"></a>
                            <a href="https://www.facebook.com/share/16G4ta5r73/" target="_blank" rel="noopener noreferrer" uk-icon="facebook"></a>
                            <a href="https://www.tiktok.com/@jai.international?_t=ZM-8zm6w4LRtmI&_r=1" target="_blank" rel="noopener noreferrer" uk-icon="tiktok"></a>

                        </div>

                        <li><a href="/">{t("ui.pages.home")}</a></li>
                        <li><a href="/why-jai">{t("ui.pages.why_jai")}</a></li>
                        <li><a href="/about">{t("ui.pages.about")}</a></li>
                        <li><a href="/team">{t("ui.pages.contacts")}</a></li>

                        {/* Services Dropdown */}
                        <li className="uk-parent">
                            <a href="#">{t("ui.pages.services_dropd")}</a>
                            <ul className="uk-nav-sub">
                                <li><a href="/travel-overview">{t("ui.pages.dropd_travel_kz")}</a></li>
                                <li><a href="/work-overview">{t("ui.pages.dropd_work_kz")}</a></li>
                                <li><a href="/study-overview">{t("ui.pages.dropd_study_kz")}</a></li>
                                <li><a className="jai-link" href="/investment/open-company">{t("ui.pages.dropd_investment")}</a></li>
                            </ul>
                        </li>

                        {/*

                    Страницы авторизации и создания аккаунта

                    <li className="uk-parent">
                        <a href="#">{t("ui.nav.account")}</a>
                        <ul className="uk-nav-sub">
                            <li><a className="jai-link" href="/sign-in">{t("ui.pages.account_login")}</a></li>
                            <li><a className="jai-link" href="/sign-up">{t("ui.pages.account_create")}</a></li>
                        </ul>
                    </li>
                    */}

                        {/* Language Selector Dropdown */}
                        <li className="uk-parent">
                            <a href="#">{t("ui.nav.lang_selector")}</a>
                            <ul className="uk-nav-sub">
                                <li><a href="#" onClick={changeLanguageToEnglish}>English</a></li>
                                {/*<li><a href="#" onClick={changeLanguageToFrench}>Français</a></li>*/}
                                <li><a href="#" onClick={changeLanguageToQazaq}>Qazaq</a></li>
                                <li><a href="#" onClick={changeLanguageToRussian}>Русский</a></li>
                            </ul>
                        </li>

                        <button className="uk-button uk-button-primary uk-margin-top" onClick={function () { setIsModalOpen(true); }}>
                            {t("ui.button.business_action.msg")}
                        </button>
                    </ul>

                </div>
            </div>
        </>
    );
}

export default OffCanvasMenuBar;
